import { useRdContext } from '@neo.tax/rd/context';
import { isRdPathAvailable, RdPath } from '@neo.tax/rd/utils';
import {
  Loader,
  NavigateTo,
  RedirectState,
  useCurrentCompanyId,
  useCurrentUserScopeForCurrentCompany,
  getDefaultRdPath,
} from '@neo.tax/shared';

export const RdPathLoader = ({
  path,
  children,
  useRedirect = (): RedirectState => ({ isLoading: false }),
}: {
  path: RdPath;
  children: React.ReactNode;
  useRedirect: () => RedirectState;
}): React.ReactElement => {
  const companyId = useCurrentCompanyId();
  const { fiscalYearId } = useRdContext();
  const { limitAccessToFinancialData } = useCurrentUserScopeForCurrentCompany();

  if (
    !isRdPathAvailable({
      isNonFinancialUser: limitAccessToFinancialData,
      path,
    })
  ) {
    return <NavigateTo to={getDefaultRdPath({ companyId, fiscalYearId })} />;
  }

  return <Loader useRedirect={useRedirect}>{children}</Loader>;
};
